import RestApiModel from "@/api/Model/RestApiModel";
import api from '@/api';

class ClaimNotifications extends RestApiModel {
  static getResourceEndpoint() {
    return '/ClaimNotifications';
  }

  static getNotificationDocumentTypes() {
    return api.get('/NotificationDocumentTypes?language={language}');
  }

  static getOfflineRaters() {
    return api.get('/GetOfflineClaimNotifciations');
  }

  static getClaimNotification(params) {
    return api.get(`/GetClaimNotificationDocument`, params);
  }

  static getClaimNotificationLink(params) {
    return api.get(`/BuildNotificationLink`, params);
  }
}

export default ClaimNotifications;